export default __webpack_public_path__ + "static/media/My project (83) 2 (2).0a1528fa.png";